/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import PopupMessage from 'material/message/popup/popup_container';



/* ========== ~~~~~~~~~~ MESSAGE : POPUP : UNSAVED : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// also receives two call back functions to route user
// this child component handles local state and uses props passed from parent to read/write application state when necessary
// Message specific component.
class UnsavedMessage extends Component {
	constructor(props) {
		super(props);
		this.state = { processing: false };
	}
	componentDidUpdate(prevProps) {
		if (!this.props.currentPage && prevProps.currentPage) { 
			this.setState({ processing: false }) 
		}
	}
	handleClick = () => {
		this.setState({ processing: true });
	}
	render() {
		return (
		    <PopupMessage
		        type={'unsaved'}
		        title={'You have unsaved changes!'}
		        body={<p>Are you sure you want to leave this page?</p>}
		        buttonPrimary={{ text: 'Leave & Discard Changes', variant: 'action', action: this.props.primaryAction, handleClick: this.handleClick, operation: 'load', processing: this.state.processing  }}
		        buttonSecondary={{ text: 'Stay on Current Page', variant: 'system', action: this.props.secondaryAction, disabled: this.state.processing }}
		    />
		)
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default UnsavedMessage;